import { render, staticRenderFns } from "./UserProfileTopShelves.vue?vue&type=template&id=30560e1b&scoped=true&"
import script from "./UserProfileTopShelves.vue?vue&type=script&lang=js&"
export * from "./UserProfileTopShelves.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileTopShelves.vue?vue&type=style&index=0&id=30560e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30560e1b",
  null
  
)

export default component.exports